import { render, staticRenderFns } from "./ModelComponent.vue?vue&type=template&id=ab862aaa&"
import script from "./ModelComponent.vue?vue&type=script&lang=js&"
export * from "./ModelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports